import { useNavigate } from "react-router-dom";
import { Navbar } from "../../../../commonComponents/HomeLayout";
import PurchaseSideSection from "./PurchaseSideSection";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../store/store";

const PurchaseLayout = ({
  heading,
  children,
}: {
  heading: string;
  children: JSX.Element;
}) => {
  const navigate = useNavigate();
  const listing = useSelector((state: RootState) => state.listings);

  return (
    <>
      <Navbar />
      <div className="purchase_page flex flex-col sm:flex-row pb-5 sm:pb-0 px-6 sm:px-[74px] gap-y-10 gap-x-[30px]">
        <div className="flex-1 p-5 sm:p-[30px]">
          <div
            onClick={() => navigate(-1)}
            className="flex gap-x-[22px] mb-[9px] cursor-pointer"
          >
            <img src="/assets/images/arrow-left.svg" alt="" />
            <p className="text-[16px] text-textBlack">Go back</p>
          </div>
          <h3 className="h3">{heading}</h3>
          <div className="responsive_flex mt-[30px] gap-[30px]">
            {children}
            <PurchaseSideSection listing={listing?.listing || undefined} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseLayout;
